import { Component } from 'react';
import { listeRessources, initialRessources, ressourcesFamille } from './lib/liste-ressources';
import { RadioBox } from './radiobox';
import { FormError } from './form-errors';
import { MontantInput } from './montant-input';
import { MontantsDetailles } from './details-montant-input';
import { MontantsLastThreeMonths } from './last-three-months';
import { getMonthText, lastThreeMonths } from './lib/utils';
import analytics, { FIELD_IDS, CONDITIONAL_IDS } from '../../services/analytics';

import arrowLeft from './../../img/arrow-pointing-left.png';
import InfoBulle from './info';

const STEP_NUMBER = 5;

/* Les montants sont saisis en net alors qu'OpenFisca attend des bruts. */
const TAUX_NET_SUR_BRUT_SALAIRE = 0.79;
const TAUX_NET_SUR_BRUT_CHOMAGE = 1 - ((0.062 + 0.005) * 0.9825 + 0.028);
/* CSG non déductible (2,4 %) + CRDS (0,5 %) sur 98,25 % du brut : écart entre net à payer et net imposable. */
const TAUX_CSG_CRDS_NON_DEDUCTIBLE = 0.029 * 0.9825;

class Ressources extends Component {
	constructor(props) {
		super(props);

		// Récupérer le field tracker pour le tracking granulaire des champs
		this.fieldTracker = analytics.getFieldTracker();

		this.state = {
			step: 'selection', // New: 'selection' or 'saisie'
			typeRessources: Object.keys(listeRessources),
			selectedRessources: {}, // New state for individual resource selection
			currentIndividu: "demandeur",
			listeIndividus: ["demandeur"],
			personnesACharge: {},
			ressources: initialRessources(),
			enfantsAyantRessources: false,
			questionPersonne: {
				"demandeur": "Percevez-vous",
				"conjoint": "Votre conjoint perçoit-il"
			},
		};
		this.state.definedRessources = [];

		// Initialize selectedRessources for all individual resources
		Object.keys(listeRessources).forEach((type) => {
			listeRessources[type].ressources.forEach((ress) => {
				this.state.selectedRessources[ress.name] = false;
			});
		});

		/* Init listeIndividus*/
		if (this.props.conjoint !== undefined) {
			this.state.listeIndividus.push("conjoint")
		}

		if (this.props.individus) {
			Object.keys(this.props.individus).forEach((individu) => {
				if (individu !== 'demandeur' && individu !== 'conjoint') {
					this.state.personnesACharge[individu] = this.props.individus[individu];
				}
			});
			this.state.listeIndividus = [...this.state.listeIndividus, ...Object.keys(this.state.personnesACharge)];
		}
		const date = new Date();
		const previousYearDateString = (date.getFullYear() - 1) + '-' + ('0' + (date.getMonth() + 1).toString()).slice(-2);
		this.dateNmoins1 = getMonthText(previousYearDateString);
		this.yearMinOne = date.getFullYear() - 1;
		const [year, month] = [date.getFullYear(), date.getMonth() + 1]

		this.thisMonth = `${year}-${month.toString().padStart(2, "0")}`;



	}

	handleCheckboxChange = (e) => {
		const { name, checked } = e.target;
		this.setState(prevState => ({
			selectedRessources: {
				...prevState.selectedRessources,
				[name]: checked
			}
		}));

		// Analytics tracking for checkbox selection
		if (this.fieldTracker) {
			const fieldId = `checkbox_${name}`;
			this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, !checked);
			this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, checked);
			this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, checked);
		}
	}

	validInputs = () => {
		let noError = true;
		// Iterate through all possible resources
		Object.keys(this.state.selectedRessources).forEach((ressourceName) => {
			// If the resource is selected AND it has an invalid flag
			if (this.state.selectedRessources[ressourceName] && this.state.ressources[ressourceName].invalid) {
				noError = false;
			}
		});

		if (!noError) {
			this.setState(() => ({ ressourceInputError: "Vérifiez les ressources saisies." }));
			return false;
		} else {
			this.setState(() => ({ ressourceInputError: "" }));
			return true;
		}
	}

	nextForm = () => {
		if (!this.validInputs()) {
			return false;
		}
		let anchor = document.getElementById('anchor');
		const yOffset = -80;
		const y = anchor.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });
		var data = {
			famille: this.props.famille
		};

		if (this.state.currentIndividu !== "demandeur" && this.state.currentIndividu !== "conjoint") {
			data.individus = this.state.personnesACharge;
			data.individus[this.state.currentIndividu].ressources = {};
		} else {
			data[this.state.currentIndividu] = {
				ressources: {}
			};
		}

		let definedRessources = this.state.definedRessources;

		/* Assigne les ressources a l'individu */
		Object.keys(this.state.ressources).forEach(
			(ressourceName) => {
				var ressources = { ...this.state.ressources };

				const ressTotal = Object.keys(ressources[ressourceName]).reduce(
					(total, date) => {
						return (typeof ressources[ressourceName][date] !== 'number')
							? total : total + ressources[ressourceName][date];
					}, 0);
				const revenuProNonSalarie = [
					'tns_auto_entrepreneur_chiffre_affaires',
					'tns_micro_entreprise_chiffre_affaires',
					'tns_autres_revenus',

				];
				var individu;


				if (ressTotal > 0) {

					if (ressourceName === 'revenus_locatifs') {
						ressources.salaire_imposable = typeof ressources.salaire_imposable === 'undefined' ?
							{} : ressources.salaire_imposable;

						Object.keys(ressources.revenus_locatifs).forEach((date) => {
							if (date !== 'show' && date !== 'details') {
								let montant = ressources.revenus_locatifs[date];

								if (!isNaN(ressources.salaire_imposable[date])) {
									ressources.salaire_imposable[date] += montant;
								} else {
									ressources.salaire_imposable[date] = montant;
								}
							}
						});

					}

					if (revenuProNonSalarie.includes(ressourceName)) {
						ressources[ressourceName][this.yearMinOne - 1] = ressources[ressourceName][this.yearMinOne];
					}

					if (ressourceName === 'revenus_locatifs') {
						ressourceName = 'salaire_imposable';
					}

					if (ressourceName === 'salaire_net' && ressources[ressourceName].details === true) {
						let date = new Date();
						let yearMinTwo = date.getFullYear() - 2;
						let curMonthString = (date.getMonth() + 1).toString().padStart(2, "0");
						let dateString = `${yearMinTwo}-${curMonthString}`;
						ressources.salaire_net = ressources[ressourceName][dateString];
					}

					else if (ressourceName === "salaire_net" && ressources[ressourceName].details === false) {
						let date = new Date();
						let _prevMonth = ((((12 + date.getMonth() - 1) % 12)) + 1).toString().padStart(2, "0"); // not date.getMonth()-1 
						let prevMonthYear = (date.getMonth()) > 0 ? parseInt(date.getFullYear()) : parseInt(date.getFullYear()) - 1;
						let previousMonth = `${prevMonthYear}-${_prevMonth}`;
						ressources.salaire_net = ressources.salaire_imposable[previousMonth];
					}

					if (this.state.currentIndividu === "demandeur" || this.state.currentIndividu === "conjoint") {
						individu = data[this.state.currentIndividu];
					} else {
						individu = data.individus[this.state.currentIndividu];
					}

					individu.ressources[ressourceName] = ressources[ressourceName];

					if (ressourceName === "tns_benefice_exploitant_agricole") {
						individu.activite = "actif"
					}

					if (!definedRessources.includes(ressourceName)) {
						definedRessources.push(ressourceName);
					}

					if (revenuProNonSalarie.includes(ressourceName)) {
						this.getTypeActivite(individu, ressourceName, ressources[ressourceName].type_activite);

						delete ressources[ressourceName].type_activite;
						delete ressources[ressourceName].continuation;
						delete ressources[ressourceName].details;
						delete ressources[ressourceName].show;
						delete ressources[ressourceName].opt_type_activite;
					}


				}

			}
		);

		/* Assigne les ressources de famille  a l'entité famille*/
		ressourcesFamille.forEach((ressourceName) => {
			if (data.famille[ressourceName] !== null && typeof data.famille[ressourceName] !== 'undefined') {
				return false;
			}
			var ressourceIndividu;
			if (this.state.currentIndividu === "demandeur" || this.state.currentIndividu === "conjoint") {
				ressourceIndividu = data[this.state.currentIndividu].ressources;

			} else {
				ressourceIndividu = data.individus[this.state.currentIndividu].ressources;

			}


			if (typeof ressourceIndividu[ressourceName] !== 'undefined') {
				data.famille[ressourceName] = { ...ressourceIndividu[ressourceName] };
				delete ressourceIndividu[ressourceName];
			} else {
				data.famille[ressourceName] = null;
			}
		});

		const indexIndividu = this.state.listeIndividus.indexOf(this.state.currentIndividu);
		if (definedRessources.length > 0) {
			data.definedRessources = definedRessources;
			//console.log(data.definedRessources);
		}

		if (indexIndividu === this.state.listeIndividus.length - 1) {
			// Tracker si l'utilisateur a des revenus salariés (is_employed)
			const hasSalary = definedRessources.includes('salaire_net') || definedRessources.includes('salaire_imposable');
			analytics.setUserIsEmployed(hasSalary);
			this.props.validateStep(data);
		} else {
			this.setState(({ listeIndividus }) => {
				const nextIndividu = listeIndividus[indexIndividu + 1];
				var newSelectedRessources = {};
				// Re-initialize selectedRessources for the next individual
				Object.keys(listeRessources).forEach((type) => {
					listeRessources[type].ressources.forEach((ress) => {
						newSelectedRessources[ress.name] = false;
					});
				});
				if ((nextIndividu !== 'demandeur' && nextIndividu !== 'conjoint') && this.state.personnesACharge[nextIndividu].hasRessources === undefined) {
					this.state.personnesACharge[nextIndividu].hasRessources = true;
				}

				return {
					currentIndividu: nextIndividu,
					step: 'selection', // Reset to selection for next individual
					selectedRessources: newSelectedRessources,
					ressources: initialRessources(),
				};
			}, () => { this.props.updateStore(data) });
		}
	}
	switchDetails = (ressourceName) => {
		const newValue = !this.state.ressources[ressourceName].details;
		this.setState(({ ressources }) => {
			ressources[ressourceName].details = newValue;
			return { ressources: ressources };
		});

		// Analytics tracking for detail toggle
		if (this.fieldTracker) {
			const fieldId = `${ressourceName}_details`;
			this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, !newValue);
			this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
			this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);
		}
	}

	showRessourceInput = (ressourceName) => {
		const newValue = !this.state.ressources[ressourceName].show;
		this.setState(({ ressources }) => {
			ressources[ressourceName].show = newValue;
			return { ressources: ressources };
		});

		// Analytics tracking for resource visibility
		if (this.fieldTracker) {
			const fieldId = `${ressourceName}_visibility`;
			this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, !newValue);
			this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
			this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);
		}
	}

	changeRessourceMontant = (montant, modelName) => {
		var thisMonth = this.thisMonth;
		this.setState(({ ressources }) => {
			if (modelName === "salaire_net") {
				ressources.salaire_de_base = {};
				ressources.salaire_imposable = {};
			} else if (modelName === "chomage_net") {
				ressources['chomage_brut'] = {};

			} else if (modelName === "retraite_nette") {
				ressources['retraite_brute'] = {};

			}

			Object.keys(ressources[modelName]).forEach((date) => {
				if (date !== 'details' && date !== 'show') {
					ressources[modelName][date] = montant;

					if (modelName === "salaire_net") {
						const salaireBrut = montant / TAUX_NET_SUR_BRUT_SALAIRE;
						ressources.salaire_de_base[date] = salaireBrut;
						ressources.salaire_imposable[date] = montant + (salaireBrut * TAUX_CSG_CRDS_NON_DEDUCTIBLE);
					} else if (modelName === "chomage_net") {
						ressources.chomage_brut[date] = montant / TAUX_NET_SUR_BRUT_CHOMAGE;

					} else if (modelName === "retraite_nette") {
						ressources.retraite_brute[date] = montant
						ressources.retraite_brute[thisMonth] = montant;
						//ressources.retraite_nette[date] = parseFloat((montant * 0.926).toFixed(13));
						ressources.retraite_nette[date] = montant;
					}
				}


			});

			Object.keys(ressources[modelName]).forEach((date) => {
				if (modelName === "retraite_nette") {
					ressources.retraite_brute[date] = montant;
					console.log('affectation');
				}
			});



			ressources[modelName][thisMonth] = montant;

			return { ressources: ressources };
		});
	}
	enfantRessourceSwitch = (value, modelName) => {
		this.setState(({ personnesACharge }) => {
			personnesACharge[modelName].hasRessources = value;
			return { personnesACharge: personnesACharge };
		});
	}

	handleRadioSwitch = (newValue, modelName) => {
		// Field tracking
		const fieldIdMap = {
			'revenu_activite': FIELD_IDS.STEP_RESOURCES.salaire,
			'allocation_chomage': FIELD_IDS.STEP_RESOURCES.chomage,
			'indemnite_maladie': FIELD_IDS.STEP_RESOURCES.indemnites_maladie,
			'pension_retraite': FIELD_IDS.STEP_RESOURCES.retraite,
			'autres_revenus': FIELD_IDS.STEP_RESOURCES.revenus_locatifs,
			'revenu_pro_non_salarie': FIELD_IDS.STEP_RESOURCES.auto_entrepreneur,
		};
		const fieldId = fieldIdMap[modelName] || `FIELD_RESOURCE_${modelName.toUpperCase()}`;
		this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, this.state.switchTypeRessource[modelName]);
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);

		// Track conditional sections for detailed resources
		if (newValue === true || newValue === 'true') {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.SALARY_DETAILS, modelName);
		}

		newValue = JSON.parse(newValue);
		this.setState(({ switchTypeRessource }) => {
			switchTypeRessource[modelName] = newValue;
			return { switchTypeRessource: switchTypeRessource };
		})

	}

	getTypeActivite = (individu, ressourceName, typeActivite) => {
		if (typeof typeActivite === 'undefined') {
			return;
		}
		const activite = typeActivite.activite ? typeActivite.activite : null;
		const type_activite = typeActivite.type_activite ? typeActivite.type_activite : null;

		const tns = {
			'tns_auto_entrepreneur_chiffre_affaires': {
				activite: "independant",
				typeActivite: (type_activite) ? "auto_entrepreneur_" + type_activite : "auto_entrepreneur_bic",
			},
			'tns_micro_entreprise_chiffre_affaires': {
				activite: "independant",
				typeActivite: (type_activite) ? "micro_entreprise_" + type_activite : "micro_entreprise_bic",
			},
			'tns_benefice_exploitant_agricole': {
				activite: "actif",
				typeActivite: null,
			},
			'tns_autres_revenus': {
				activite: "independant",
				typeActivite: null,
			},
		};

		if (activite === null) {
			return;
		}
		individu.activite = activite;

		if (activite === "independant" && type_activite !== null) {
			individu.tns_type_activite = tns[ressourceName].typeActivite;
		}


	}
	getTypeActiviteOptions = (ressource) => {
		const bnc_bic = [
			{ label: "Bénéfices non commerciaux (BNC) - ex. freelance", value: "bnc" },
			{ label: "Bénéfices industriels et commerciaux (BIC) - ex. commercant , artisan", value: "bic" },
		];
		const bnc_bic_ba = [
			{ label: "Bénéfices non commerciaux (BNC) - ex. freelance", value: "bnc" },
			{ label: "Bénéfices industriels et commerciaux (BIC) - ex. commercant , artisan", value: "bic" },
			{ label: "Bénéfices agricoles (BA)", value: "ba" },
		];

		const autoEntrepreneurOptions = [
			{
				label: "Vente de marchandise, restauration et hébergement (BIC)", value: "vente_marchandise"
			},
			{
				label: "Prestation de services commerciales ou artisanales (BIC / BNC)", value: "prestation_service_bic_bnc"
			},
			{
				label: "Autres services et activités libérales (BNC)", value: "autre_service_activite"
			},
		];


		switch (ressource) {
			case 'tns_auto_entrepreneur_chiffre_affaires':
				return autoEntrepreneurOptions;
			case 'tns_micro_entreprise_chiffre_affaires':
				return bnc_bic;
			case 'tns_autres_revenus':
				return bnc_bic_ba;
			default:
				return null;
		}
	}

	captureTypeActivite = (ressourceName, value) => {
		this.setState(({ ressources }) => {
			ressources[ressourceName].type_activite = {
				type_activite: value,
				activite: "independant",
			};
			return { ressources: ressources };
		});
	}

	captureYear = (montant, modelName, year) => {
		this.setState(({ ressources }) => {
			ressources[modelName].show = true;
			ressources[modelName].details = true;
			ressources[modelName][year] = montant;
			return { ressources: ressources };
		});
	}
	formAutoEntrepreneur = () => {
		const ressource = 'tns_auto_entrepreneur_chiffre_affaires';
		return <div className="auto-entrepreneur">
			<h4>Activité auto-entrepreneur</h4>
			<div className="question-type-activite">
				<label for="tns_auto_entrepreneur_type_activite">Type d'activité</label>
				<select
					className="type_activite"
					name={ressource}
					defaultValue={this.state.ressources[ressource].type_activite}
					onChange={(e) => (this.captureTypeActivite(ressource, e.target.value))}
				>
					{this.state.ressources[ressource].opt_type_activite.map((option) => {
						return <option value={option.value} >{option.label}</option>
					})}
				</select>
			</div>

			<MontantInput
				name={ressource}
				model={this.state.ressources[ressource][this.yearMinOne]}
				modelName={ressource}
				handler={(montant, modelName) => (this.captureYear(montant, modelName, this.yearMinOne))}
			>Chiffre d'affaire annuel ({this.yearMinOne})</MontantInput>

		</div>;
	}

	formMicroEntreprise = () => {
		const ressource = 'tns_micro_entreprise_chiffre_affaires';
		return <div className="micro-entreprise">
			<h4>Micro-entreprise</h4>
			<div className="question-type-activite">
				<label for="tns_micro_entreprise_type_activite">Type d'activité</label>
				<select
					className="type_activite"
					name={ressource}
					defaultValue={this.state.ressources[ressource].type_activite}
					onChange={(e) => (this.captureTypeActivite(ressource, e.target.value))}
				>
					{this.state.ressources[ressource].opt_type_activite.map((option) => {
						return <option value={option.value} >{option.label}</option>
					})}
				</select>
			</div>

			<MontantInput
				name={ressource}
				model={this.state.ressources[ressource][this.yearMinOne]}
				modelName={ressource}
				handler={(montant, modelName) => (this.captureYear(montant, modelName, this.yearMinOne))}
			>Chiffre d'affaire annuel ({this.yearMinOne})</MontantInput>

		</div>;
	}

	formProfessionLiberale = () => {
		const ressource = 'tns_autres_revenus';
		return <div className="profession-liberale">
			<h4>Profession libérale</h4>
			<div className="question-type-activite">
				<label for="tns_autres_revenus_type_activite">Type d'activité</label>
				<select
					className="type_activite"
					name={ressource}
					defaultValue={this.state.ressources[ressource].type_activite}
					onChange={(e) => (this.captureTypeActivite(ressource, e.target.value))}
				>
					{this.state.ressources[ressource].opt_type_activite.map((option) => {
						return <option value={option.value} >{option.label}</option>
					})}
				</select>
			</div>

			<MontantInput
				name={ressource}
				model={this.state.ressources[ressource][this.yearMinOne]}
				modelName={ressource}
				handler={(montant, modelName) => (this.captureYear(montant, modelName, this.yearMinOne))}
			>Bénéfice annuel ({this.yearMinOne})</MontantInput>

		</div>;
	}

	formExploitantAgricole = () => {
		const ressource = 'tns_benefice_exploitant_agricole';
		return <div className="exploitant-agricole">
			<h4>Exploitant agricole</h4>

			<MontantInput
				name={ressource}
				model={this.state.ressources[ressource][this.yearMinOne]}
				modelName={ressource}
				handler={(montant, modelName) => (this.captureYear(montant, modelName, this.yearMinOne))}
			>Bénéfice sur le dernier exercice clos</MontantInput>

		</div>;
	}
	captureMontantDetailler = (montants, modelName) => {
		this.setState(({ ressources }) => {
			ressources[modelName].details = true;
			ressources[modelName].show = true;
			if (modelName === "salaire_net") {
				ressources.salaire_de_base = {};
				ressources.salaire_imposable = {
					details: true,
				};
			} else if (modelName === "chomage_net") {
				ressources['chomage_brut'] = {};
			} else if (modelName === "retraite_nette") {
				ressources['retraite_brute'] = {

				};
			}

			Object.keys(montants).forEach((date) => {
				const montant = montants[date];
				if (date !== 'details' && date !== 'show') {

					ressources[modelName][date] = montant;

					if (modelName === "salaire_net") {
						const salaireBrut = montant / TAUX_NET_SUR_BRUT_SALAIRE;
						ressources.salaire_de_base[date] = salaireBrut;
						ressources.salaire_imposable[date] = montant + (salaireBrut * TAUX_CSG_CRDS_NON_DEDUCTIBLE);
					} else if (modelName === "chomage_net") {
						ressources.chomage_brut[date] = montant / TAUX_NET_SUR_BRUT_CHOMAGE;
						ressources.chomage_net[date] = montant;

					} else if (modelName === "retraite_nette") {
						ressources.retraite_brute = montant;
					}
				}
			});

			return { ressources: ressources };
		});
	}
	submitEnfantsAyantsRessources = () => {
		var noRessources = true;
		var enfantsAyantRessources = [];
		Object.keys(this.state.personnesACharge).forEach((individu) => {

			if (this.state.personnesACharge[individu].hasRessources) {
				enfantsAyantRessources.push(individu);
				noRessources = false;
			}

		});
		if (noRessources) {
			this.props.validateStep()
		} else {
			this.setState(() => {
				return {
					enfantsAyantRessources: false,
					listeIndividus: enfantsAyantRessources
				}
			})
		}
	}

	getRevenuForm = (ressource, monthString) => {
		if (!this.state.ressources[ressource.name].show) {
			return '';
		}

		if (ressource.name === 'tns_auto_entrepreneur_chiffre_affaires') {
			return this.formAutoEntrepreneur();
		} else if (ressource.name === 'tns_benefice_exploitant_agricole') {
			return this.formExploitantAgricole();
		} else if (ressource.name === 'tns_micro_entreprise_chiffre_affaires') {
			return this.formMicroEntreprise();
		} else if (ressource.name === 'tns_autres_revenus') {
			return this.formProfessionLiberale();
		}
		return (this.state.ressources[ressource.name].show) ?
			<div className="ressource-input-container fade-in">
				{(!this.state.ressources[ressource.name].details) ?
					<div className="saisi-montant">

						<MontantInput
							name={ressource.name}
							model={this.state.ressources[ressource.name][monthString]}
							modelName={ressource.name}
							handler={this.changeRessourceMontant}

						>
							Montant perçu chaque mois
						</MontantInput>
					</div>
					: <div className="saisi-montant details">
						<MontantsDetailles
							name={ressource.name}
							modelName={ressource.name}
							handler={this.captureMontantDetailler}
							single={ressource.single}
						>
						</MontantsDetailles>
					</div>
				}
				<small className="detail-button"
					onClick={(e) => (this.switchDetails(ressource.name))}
				>
					{(this.state.ressources[ressource.name].details) ?
						'Montant fixe perçu chaque mois'
						: 'détaillez les montants sur les 12 derniers mois'}
				</small>
			</div>
			: '';

	}

	renderSelectionStep = () => {
		const currentIndividu = this.state.currentIndividu;
		const question = (['demandeur', 'conjoint'].includes(currentIndividu))
			? this.state.questionPersonne[currentIndividu]
			: (this.state.personnesACharge[currentIndividu].name) + " perçoit-il·elle ";

		return (<div className="step-inner-container etape-ressources">
			<div className="etape-ressources-top">
				<div className="prev-btn-container">
					<button onClick={this.previous} className="btn-previous"><img className="img-previous" src={arrowLeft} />Précedent</button>
				</div>
				<h2>
					{(['demandeur', 'conjoint'].includes(this.state.currentIndividu)) ?
						({
							"demandeur": "Vos Ressources",
							"conjoint": "Les ressources de votre conjoint",
						})[this.state.currentIndividu]
						: "Les ressources de " + (this.state.personnesACharge[this.state.currentIndividu].name).toLowerCase()
					}
				</h2>
			</div>

			{Object.keys(listeRessources).map(ressourceTypeKey => {
				const ressourceCategory = listeRessources[ressourceTypeKey];
				return (
					<div key={ressourceCategory.name} className="ressource-category-selection">
						<h3>{ressourceCategory.label}</h3>
						{ressourceCategory.ressources.map(ressource => (
							<div className="ressource-selection-item" key={ressource.name}>
								<input
									type="checkbox"
									id={`checkbox-${ressource.name}`}
									name={ressource.name}
									checked={this.state.selectedRessources[ressource.name] || false}
									onChange={this.handleCheckboxChange}
								/>
								<label htmlFor={`checkbox-${ressource.name}`}>
									<span className="question-ressource ">{ressource.label}</span>
								</label>
							</div>
						))}
					</div>
				);
			})}

			<button
				onClick={() => {
					const hasSelection = Object.values(this.state.selectedRessources).some(Boolean);
					if (hasSelection) {
						this.setState({ step: 'saisie' });
					} else {
						this.nextForm();
					}
				}}
				className="ressource-validate"
			>Valider</button>
			<div className="button-container previous">
				<button onClick={this.restart}> Recommencer </button>
			</div>
		</div>
		);
	}

	renderSaisieStep = () => {
		const monthString = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() - 1)).slice(-2);

		return (
			<div className="step-inner-container etape-ressources">
				<div className="etape-ressources-top">
					<div className="prev-btn-container">
						<button onClick={() => this.setState({ step: 'selection' })} className="btn-previous">
							<img className="img-previous" src={arrowLeft} />Précedent
						</button>
					</div>
					<h2>
						{(['demandeur', 'conjoint'].includes(this.state.currentIndividu)) ?
							({
								"demandeur": "Vos Ressources",
								"conjoint": "Les ressources de votre conjoint",
							})[this.state.currentIndividu]
							: "Les ressources de " + (this.state.personnesACharge[this.state.currentIndividu].name).toLowerCase()
						}
					</h2>
				</div>

				{Object.keys(this.state.selectedRessources).map(ressourceName => {
					if (this.state.selectedRessources[ressourceName]) {
						// Find the category and the specific ressource object
						let ressourceObj = null;
						for (const typeKey in listeRessources) {
							const category = listeRessources[typeKey];
							ressourceObj = category.ressources.find(r => r.name === ressourceName);
							if (ressourceObj) {
								break;
							}
						}

						if (!ressourceObj) {
							return null; // Should not happen if data is consistent
						}

						// Render the input for the selected resource
						return (
							<div key={ressourceName} className="revenu-amount">
								<h3 className="ress-title">{ressourceObj.label}</h3>
								{this.getRevenuForm(ressourceObj, monthString)}
							</div>
						);
					}
					return null;
				})}

				<div className="error-container">
					<FormError errors={[this.state.ressourceInputError]} />
				</div>
				<button onClick={this.nextForm} className="ressource-validate">Valider</button>
				<div className="button-container previous">
					<button onClick={this.restart}> Recommencer </button>
				</div>
			</div>
		);
	}

	questionRessourcesEnfants = () => {
		const months = [
			'janvier',
			'février',
			'mars',
			'avril',
			'mai',
			'juin',
			'juillet',
			'aout',
			'septembre',
			'octobre',
			'novembre',
			'décembre'
		];
		const month = months[new Date().getMonth()];
		const previousYear = (new Date().getFullYear()) - 1;
		return <div className="question-ressources-enfants">
			{Object.keys(this.state.personnesACharge).map((individu, i) => {

				return <RadioBox
					name={'revenu_enfant_' + i}
					options={{
						"Oui": true,
						"Non": false,
					}}
					handler={this.enfantRessourceSwitch}
					defaultValue={this.state.personnesACharge[individu].hasRessources}
					modelName={individu}
				><h3>{this.state.personnesACharge[individu].name} a-t-il·elle perçu des ressources depuis {month} {previousYear} ?</h3></RadioBox>;

			})}
			<button onClick={this.submitEnfantsAyantsRessources} >Valider</button>
		</div>;
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = () => {
		this.props.restart();
	}

	render() {
		if (this.state.enfantsAyantRessources) {
			return <div className="step-inner-container etape-ressources">{this.questionRessourcesEnfants()}</div>
		}

		if (this.state.step === 'selection') {
			return this.renderSelectionStep();
		} else { // 'saisie'
			return this.renderSaisieStep();
		}
	}
}

export default Ressources;